module.exports = __webpack_public_path__ + "media/ו.32387ae7.mp3";